export { GiftTemplateComponent } from './gift-template/gift-template.component';
export { RedemptionTemplateComponent } from './redemption-template/redemption-template.component';
export { RedemptionV2TemplateComponent } from './redemption-v2-template/redemption-v2-template.component';
export {JoingoTemplateComponent } from './joingo-template/joingo-template.component';